import React from 'react'
import './assets/stylesheet/Navbar.css';
import Hamburger from './Hamburger';
import Scrollchor from 'react-scrollchor';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

const Navbar = props => (
    <div className="topnav">
        <Link to="/" id="nav-logo">
            <img id="logo" src={require("./assets/images/logo.png")} />
            <div id="name"><strong>I N E R T I A</strong></div>
        </Link>
        <div className="toggleDiv">
            <Hamburger click={props.drawerClickHandler}/>
        </div>
        <div style={{ paddingRight : '10vw' }} id="nav-items">
        {/*    <Link className="not-register" to="/">Home</Link> */}
            <Scrollchor className="not-register" to="#mission">About</Scrollchor>
            <Scrollchor className="not-register" to="#commInfo">Subscribe</Scrollchor>
      {/*      <a href="/#/register" className="register button">Register</a> */}
        </div>
    </div>
)

export default Navbar
